// noinspection JSUnusedGlobalSymbols
export enum IdentifierType {
  Guid = 'Guid',
  Pstn = 'Pstn',
  Encrypted = 'Encrypted',
  AcsUser = 'AcsUser',
}
